console.log('Vite ⚡️ Rails')

import { Turbo } from '@hotwired/turbo-rails'
Turbo.start()

import '/config'
import '/controllers'
import '/channels'
import '/turbo_streams'

import Confirm from '/libs/confirm'
Confirm.railsSetup()

// CSS
import 'easymde/dist/easymde.min.css'
